import { Input } from "design-react-kit";
import moment from "moment";
import React, { useEffect, useState, useContext } from "react";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useLocation, useHistory } from "react-router-dom";
import Select from "../../Components/Select";
import Loader from "../../Components/Loader";
import UploadFile from "../../Components/UploadFile";
import { TokenContext } from "../../Components/TokenContext";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function NewAnnouncement(props) {
  const apiToken = useContext(TokenContext);
  const d = new Date();
  const [selectedService, setSelectedService] = useState(false);
  const [servicesList, setServicesList] = useState();
  const [serviceId, setServiceId] = useState();
  const [isOpen, toggleModal] = useState(false);
  const [serviceName, setServiceName] = useState();
  // const [rangesList, setRangesList] = useState([]);
  const [arrRanges1, setArrRanges1] = useState();
  const [arrRangesFilter1, setArrRangesFilter1] = useState();
  const [arrRangesTemp1, setArrRangesTemp1] = useState([]);
  const [arrRanges2, setArrRanges2] = useState([]);
  const [arrRangesTemp2, setArrRangesTemp2] = useState([]);
  const [validation, setValidation] = useState(false);
  const [servizi, setServizi] = useState([]);
  const [servizioTemp, setServizioTemp] = useState();
  const [loading, setLoading] = useState(true);
  const [filterRange, setFilterRange] = useState();

  const history = useHistory();

  const [errorMessage, setErrorMessage] = useState(false);

  let query = useQuery();

  const [data, setData] = useState({
    serviceId: query.get("id"),
    name: query.get("name") && query.get("name") + " - " + d.getFullYear(),
    cost: null,
    bandsId: null,
  });

  useEffect(() => {
    if (apiToken) {
      setLoading(false);

      if (query.get("id") && query.get("name")) {
        setServiceId(query.get("id"));
        setServiceName(query.get("name"));
        setSelectedService(true);
      } else {
        Repo.getServices(apiToken)
          .then((response) => {
            setServicesList(response.data);
            setLoading(true);
          })
          .catch((error) => {
            console.log(error);
            setLoading(true);
          });
      }
      Repo.getRangesList(apiToken)
        .then((response) => {
          setArrRanges1(response.data);
          setArrRangesFilter1(response.data);
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });

      Repo.getListaServizi(apiToken)
        .then((response) => {
          setServizi(response.data);
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });
    }
  }, []);

  const checkSession = () => {
    setValidation(true);
    let passedValidation = true;

    if (data.serviceId == null) passedValidation = false;
    if (data.name == null) passedValidation = false;
    if (data.codAccertamento == null) passedValidation = false;
    if (data.codCapitolo == null) passedValidation = false;
    if (data.nomeMyPay == null) passedValidation = false;
    if (passedValidation) {
      toggleModal(!isOpen);
    }
  };

  const postInsertSession = () => {
    Repo.postInsertSession(apiToken, JSON.stringify(data))
      .then((response) => {
        if (response.status == 200) {
          window.location.href =
            props.subfolder +
            "/lista_bandi?id=" +
            serviceId +
            "&name" +
            serviceName;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChangeRange = (event, percent, fixedcost) => {
    if (event) {
      let name = event.target.name;

      let id = event.target.id;
      let checked = event.target.checked;
      let value = event.target.value;

      switch (name) {
        case "checkBox1":
          if (checked) {
            setArrRangesTemp1((prevState) => [
              ...prevState,
              {
                id: id,
                name: value,
                percent: percent,
                fixedCost: fixedcost,
              },
            ]);
            break;
          } else {
            var arr = arrRangesTemp1.filter((item) => item.id !== id);

            setArrRangesTemp1(arr);

            break;
          }

        case "checkBox2":
          if (checked) {
            setArrRangesTemp2((prevState) => [
              ...prevState,
              {
                id: id,
                name: value,
                percent: percent,
                fixedCost: fixedcost,
              },
            ]);
            break;
          } else {
            var arr = arrRangesTemp2.filter((item) => item.id !== id);

            setArrRangesTemp2(arr);

            break;
          }

        default:
          break;
      }
    }
  };

  const transferRange = (bool) => {
    if (bool) {
      setArrRanges2(arrRanges2.concat(arrRangesTemp1));

      var arr = arrRanges1.filter(function (obj) {
        return !arrRangesTemp1.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });

      var arr2 = arrRangesTemp1.filter(function (obj) {
        return !arrRanges1.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });

      var result = arr.concat(arr2);

      setArrRanges1(result);
      setArrRangesTemp1([]);
    } else {
      setArrRanges1(arrRanges1.concat(arrRangesTemp2));

      var arr = arrRanges2.filter(function (obj) {
        return !arrRangesTemp2.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });

      var arr2 = arrRangesTemp2.filter(function (obj) {
        return !arrRanges2.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });

      var result = arr.concat(arr2);

      setArrRanges2(result);
      setArrRangesTemp2([]);
    }
  };

  useEffect(() => {
    if (filterRange) {
      var arr = arrRanges1.filter(function (obj) {
        return obj.name.toLowerCase().includes(filterRange.toLowerCase());
      });
      setArrRanges1(arr);
    } else if (arrRanges2 && arrRangesFilter1) {
      var arr2 = arrRangesFilter1.filter(function (obj) {
        return !arrRanges2.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });
      setArrRanges1(arr2);
    }
  }, [filterRange]);

  const transferBlock = () => {
    return (
      <>
        <div className="row mt-4">
          <div className="col-xs-12 col-md-5">
            <Input
              id="filterRange"
              label="Ricerca Fasce Isee"
              type="text"
              name="filterRange"
              value={servizioTemp ? filterRange : ""}
              onChange={(e) => setFilterRange(e.target.value)}
            />
          </div>
        </div>
        <div className="it-transfer-block">
          <div className="row">
            <div className="col-xs-12 col-md-5">
              <div className="it-transfer-wrapper source">
                <div className="transfer-header">
                  <div className="form-check" aria-describedby="">
                    <label htmlFor="checkbox1">
                      <span>FASCE ISEE DISPONIBILI</span>
                    </label>
                  </div>
                </div>
                <div className="transfer-scroll">
                  <div className="transfer-group">
                    {arrRanges1 &&
                      arrRanges1.length > 0 &&
                      arrRanges1.map((x, index) => (
                        <div
                          key={x.id}
                          className="form-check"
                          aria-describedby=""
                        >
                          <input
                            id={x.id}
                            value={x.name}
                            type="checkbox"
                            name="checkBox1"
                            onChange={(e) =>
                              handleChangeRange(e, x.percent, x.fixedCost)
                            }
                            {...(arrRangesTemp1 &&
                            arrRangesTemp1.length > 0 &&
                            arrRangesTemp1.find((y) => y.id == x.id)
                              ? {
                                  checked: true,
                                }
                              : { checked: false })}
                          />

                          <label htmlFor={x.id}>
                            <span>
                              <span>
                                {typeof x.percent != "object" && x.percent
                                  ? x.name +
                                    " (" +
                                    x.percent +
                                    "% di " +
                                    x.fixedCost +
                                    " €)"
                                  : x.name + " (" + x.fixedCost + " €)"}
                              </span>
                            </span>
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
            {/* Button */}
            <div className="col-xs-12 col-md-2">
              <div className="it-transfer-buttons">
                {arrRangesTemp1 && arrRangesTemp1.length > 0 ? (
                  <>
                    <button
                      className="btn btn-outline-primary rounded-circle p-0"
                      style={{ width: "40px", height: "40px" }}

                      onClick={() => transferRange(true)}
                      aria-label="Sposta avanti"
                    >
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-arrow-right`}></use>
                      </svg>
                    </button>
                    <span className="sr-only">Label for arrow right</span>{" "}
                  </>
                ) : (
                  <>
                    <button
                      type="button"
                      className="btn btn-outline-primary rounded-circle p-0"
                      style={{ width: "40px", height: "40px" }}
                      aria-label="Sposta avanti"
                      title="Sposta avanti"
                    >
                      <svg className="icon icon-primary icon-sm">
                        <use href={`${iconSprite}#it-arrow-right`} />
                      </svg>
                    </button>
                  </>
                )}

                {arrRangesTemp2 && arrRangesTemp2.length > 0 ? (
                  <>
                    <button
                       style={{ width: "40px", height: "40px" }}
                      className="backtransfer mt-2 btn btn-outline-primary rounded-circle p-0"
                      href="#"
                      aria-label="Sposta indietro"
                      onClick={() => transferRange(false)}
                    >
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-arrow-left`}></use>
                      </svg>
                    </button>
                    <span className="sr-only">Label for arrow left</span>
                  </>
                ) : (
                  <>
                    <button
                     className="btn btn-outline-primary rounded-circle p-0 mt-2"
                       style={{ width: "40px", height: "40px" }}
                      aria-label="Sposta avanti"
                    >
                      <svg className="icon icon-info">
                        <use href={`${iconSprite}#it-arrow-left`}></use>
                      </svg>
                    </button>
                  </>
                )}
              </div>
            </div>
            <div className="col-xs-12 col-md-5">
              <div className="it-transfer-wrapper target">
                <div className="transfer-header">
                  <div className="form-check" aria-describedby="">
                    <label htmlFor="checkbox1b">
                      <span>
                        <span>FASCE ISEE SELEZIONATE</span>
                      </span>
                    </label>
                  </div>
                </div>
                <div className="transfer-scroll">
                  <div className="transfer-group">
                    {arrRanges2 &&
                      arrRanges2.length > 0 &&
                      arrRanges2.map((x, index) => (
                        <div
                          key={x.id}
                          className="form-check"
                          aria-describedby=""
                        >
                          <input
                            id={x.id}
                            value={x.name}
                            type="checkbox"
                            name="checkBox2"
                            onChange={(e) =>
                              handleChangeRange(e, x.percent, x.fixedCost)
                            }
                            {...(arrRangesTemp2 &&
                            arrRangesTemp2.length > 0 &&
                            arrRangesTemp2.find((y) => y.id == x.id)
                              ? {
                                  checked: true,
                                }
                              : { checked: false })}
                          />
                          <label htmlFor={x.id}>
                            <span>
                              {typeof x.percent != "object" && x.percent
                                ? x.name +
                                  " (" +
                                  x.percent +
                                  "% di " +
                                  x.fixedCost +
                                  " €)"
                                : x.name + " (" + x.fixedCost + " €)"}
                            </span>
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <h1>Inserimento bando</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>
          Inserimento di un nuovo bando per il servizio o duplica da bando
          precedente
        </p>
      </div>

      <div className="row mt-2">
        <div className="col-lg-12 text-right">
          <button
            type="button"
            className="btn btn-secondary"
            data-toggle="tooltip"
            data-placement="top"
            onClick={() => history.goBack()}
            title="Torna indietro"
          >
            Indietro
          </button>
        </div>
      </div>

      <div className="row">
        <div className="bootstrap-select-wrapper col-lg-6">
          <Select
            aria-label="Servizio"
            clearText="Annulla"
            defaultMenuIsOpen={false}
            required
            icon={false}
            name="servizio"
            id="servizio"
            options={servizi}
            onChange={(e) => {
              setServizioTemp(e ? e.label : null);
              setData({ ...data, serviceId: e.value });
              setServiceName();
            }}
            isClearable
            isSearchable
            value={data.serviceId}
            placeholder={
              servizioTemp
                ? servizioTemp
                : serviceName
                ? serviceName
                : "Seleziona servizio*"
            }
          />
          {validation && !data.serviceId ? (
            <small id="errorSelect" className="form-text text-danger">
              Il campo non può essere vuoto!
            </small>
          ) : (
            <></>
          )}
        </div>
        <div className="col-lg-6">
          <Input
            id="title"
            label="Titolo*"
            type="text"
            name="title"
            value={data && data.name ? data.name : ""}
            onChange={(e) => setData({ ...data, name: e.target.value })}
            {...(validation &&
              !data.name && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
          />
        </div>
        {/* <div className="col-lg-4">
                  <Input
                    id="cost"
                    label="Costo prestazione"
                    type="number"
                    name="cost"
                    onChange={(e) => setData({ ...data, cost: e.target.value })}
                    infoText="Inserire il valore solo se non sono presenti fasce ISEE"
                  />
                </div> */}
      </div>
      <div className="row mt-4 mb-2">
        <div className="col-lg-4">
          <Input
            id="nomeMyPay"
            label="Nome Servizio MyPay*"
            type="text"
            name="nomeMyPay"
            value={data.nomeMyPay || data.nomeMyPay || ""}
            onChange={(e) => setData({ ...data, nomeMyPay: e.target.value })}
            {...(validation &&
              !data.nomeMyPay && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
          />
        </div>
        <div className="col-lg-4">
          <Input
            id="codAccertamento"
            label="Codice Accertamento*"
            type="text"
            name="codAccertamento"
            value={data.codAccertamento || data.codAccertamento || ""}
            onChange={(e) =>
              setData({
                ...data,
                codAccertamento: e.target.value,
              })
            }
            {...(validation &&
              !data.codAccertamento && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
          />
        </div>
        <div className="col-lg-4">
          <Input
            id="codCapitolo"
            label="Codice Capitolo*"
            type="text"
            name="codCapitolo"
            value={data.codCapitolo || data.codCapitolo || ""}
            onChange={(e) => setData({ ...data, codCapitolo: e.target.value })}
            {...(validation &&
              !data.codCapitolo && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
          />
        </div>
      </div>
      <h6>Fasce ISEE:</h6>
      {transferBlock()}

      <div className="row mt-3">
        <div className="col-lg-12 text-right">
          <button
            type="button"
            className="btn btn-primary"
            data-toggle="tooltip"
            data-placement="top"
            onClick={() => checkSession()}
            title="Conferma"
          >
            Conferma
          </button>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Inserimento nuovo bando"
        body="Confermi di voler inserire un nuovo bando?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => postInsertSession()}
      ></ModalComponent>
      {!loading && <Loader></Loader>}
    </>
  );
}

export default NewAnnouncement;
